import Switch from '@mui/material/Switch';
import * as muiStyles from '@mui/material/styles';

import { colors } from 'theme/colors';

// oxlint-disable-next-line no-empty-pattern
export const StyleMUISwitch = muiStyles.styled(Switch)(({}) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.primary.main,
    '&:hover': {
      backgroundColor: colors.tint.primary.light,
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.primary.main,
  },
  '& .MuiTypography-root': {
    color: colors.text.primary,
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    display: 'flex',
    alignSelf: 'center',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));
